import { movies, type Movie } from '@/mocks/movies';
import { stars, type Star } from '@/mocks/stars';
import { news, type NewsItem } from '@/mocks/news';

export function getMovieById(id: string): Movie | undefined {
  return movies.find((movie) => movie.id === id);
}

export function getStarById(id: string): Star | undefined {
  return stars.find((star) => star.id === id);
}

export function getNewsById(id: string): NewsItem | undefined {
  return news.find((item) => item.id === id);
}

export function getMoviesByIds(ids: string[]): Movie[] {
  return ids
    .map((id) => movies.find((movie) => movie.id === id))
    .filter((movie): movie is Movie => Boolean(movie));
}

export function searchMovies(query: string): Movie[] {
  const keyword = query.trim().toLowerCase();
  if (!keyword) return [];
  return movies.filter((movie) => {
    const haystack = [movie.title, movie.type, String(movie.year), movie.region, ...movie.genres, ...movie.cast]
      .join(' ')
      .toLowerCase();
    return haystack.includes(keyword);
  });
}

export function searchStars(query: string): Star[] {
  const keyword = query.trim().toLowerCase();
  if (!keyword) return [];
  return stars.filter((star) => {
    const haystack = [star.name, star.profession, ...star.tags, star.nationality].join(' ').toLowerCase();
    return haystack.includes(keyword);
  });
}

export function getNewsByStar(starId: string): NewsItem[] {
  const star = getStarById(starId);
  return news.filter((item) => {
    if (item.relatedStar === starId) return true;
    if (star && item.relatedMovie) {
      return star.representativeWorks.includes(item.relatedMovie);
    }
    return false;
  });
}

export function formatDate(date: string): string {
  const [year, month, day] = date.split('-');
  return `${year}年${Number(month)}月${Number(day)}日`;
}